// extracted by mini-css-extract-plugin
export default {"container":"Side_container__6qzNi","menus":"Side_menus__XynpQ","submenu":"Side_submenu__SarH2","open":"Side_open__dux7Q"};